(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    // Text truncation show-more functionality
  document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.text-truncate-wrapper');
    
    wrappers.forEach(wrapper => {
      const truncatedElement = wrapper.querySelector('.text-truncated');
      const fullElement = wrapper.querySelector('.text-full');
      const button = wrapper.querySelector('.text-show-more-button');
      
      if (!truncatedElement || !fullElement || !button) return;
      
      // Check if content is actually being truncated
      const isOverflowing = truncatedElement.scrollHeight > truncatedElement.clientHeight;
      
      if (isOverflowing) {
        button.style.display = 'inline-flex';
        
        button.addEventListener('click', () => {
          const isExpanded = wrapper.getAttribute('data-expanded') === 'true';
          
          if (isExpanded) {
            // Collapse
            truncatedElement.style.display = '-webkit-box';
            fullElement.style.display = 'none';
            wrapper.setAttribute('data-expanded', 'false');
            button.setAttribute('aria-expanded', 'false');
          } else {
            // Expand
            truncatedElement.style.display = 'none';
            fullElement.style.display = 'block';
            wrapper.setAttribute('data-expanded', 'true');
            button.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
